/**
 * @file AdUnitBlogRowSlot.tsx
 *
 * @fileoverview Renders row ad unit for a blog detail page.
 *  This ad banner occupies the full width.
 */

interface AdUnitBlogRowSlotProps {
  row: {
    bundle?: string;
    adUnitId?: string;
  };
}

export default function AdUnitBlogRowSlot({
  row: { bundle, adUnitId },
}: AdUnitBlogRowSlotProps) {
  return <></>;
}

export { AdUnitBlogRowSlot };
